var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNoDataIllu(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 233.9,
    height: 220.277,
    viewBox: "0 0 233.9 220.277",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_1286",
    "data-name": "Group 1286",
    transform: "translate(0 0.273)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--background-simple--inject-46",
    transform: "translate(0 2.324)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_9419",
    "data-name": "Path 9419",
    d: "M16.688,162.913s4.022,35.075,33.829,50.062,59,.406,85.805-3.105c14.039-1.84,27.058,5.065,40.82,6.509,44.007,4.621,78.547-47.243,72.349-85.393-5.349-33.022-26.461-56.335-64.92-72.963S119.667,28.161,75,43.792,13.506,117.483,16.688,162.913Z",
    transform: "translate(-16.313 -36.817)",
    fill: "#ffaf20"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9420",
    "data-name": "Path 9420",
    d: "M16.688,162.913s4.022,35.075,33.829,50.062,59,.406,85.805-3.105c14.039-1.84,27.058,5.065,40.82,6.509,44.007,4.621,78.547-47.243,72.349-85.393-5.349-33.022-26.461-56.335-64.92-72.963S119.667,28.161,75,43.792,13.506,117.483,16.688,162.913Z",
    transform: "translate(-16.313 -36.817)",
    fill: "#fff",
    opacity: 0.8
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Plants--inject-46",
    transform: "translate(0 105.881)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_777",
    "data-name": "Line 777",
    x2: 224.215,
    transform: "translate(0 84.032)",
    fill: "none",
    stroke: "#263238",
    strokeWidth: 0.546
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9421",
    "data-name": "Path 9421",
    d: "M252.579,162.119a14.881,14.881,0,0,0-7.24,4.445,31.428,31.428,0,0,0-4.374,5.965c-.8,1.359-1.52,2.769-2.18,4.2-.433.932-.757,2.1-1.165,3.164-.589.951-1.171,1.941-1.669,2.827,1.766-6.314,7.414-17.941,7.518-21.247.1-3.6-3.338,1.773-5.279,9.058a102.179,102.179,0,0,0-2.471,12.616c-.2.369-.382.731-.537,1.068-.349.738-.951,1.993-1.753,3.623,1.708-5.363,2.394-11.736,1.333-12.532-1.527-1.139-2.083,1.663-2.083,6.826a45.118,45.118,0,0,1-1.824,10.856c-.964,1.941-2.044,4.018-3.2,6.23,1.21-3.882,1.909-9.433,2.588-13.586.964-6.069.55-7.958-1.417-5.046s-1.617,7.117-1.152,12.293a21.552,21.552,0,0,1-1.753,9.653c-1.482,2.808-3.054,5.713-4.639,8.566a29.373,29.373,0,0,0,2.53-9.258c.679-7.02-.226-13.457-1.844-11.646s-.647,6.709-.848,12.648a66.993,66.993,0,0,1-1.262,10.766l-.485.854a29.056,29.056,0,0,0,.472-9.142c.323-1.177.214-1.941-.175-2.284-.058-1.294.052-3.306-.511-4.322-1.417-2.53-2.976.886-2.989,2.226a22.322,22.322,0,0,0,.213,3.078,7.9,7.9,0,0,0-1.423,1.748c-.214.356-.44.763-.647,1.2,0-.421.045-.848.065-1.294a6.23,6.23,0,0,0-.7-3.306,20.572,20.572,0,0,0,1.831-5.389,2.976,2.976,0,0,0-.162-1.87,1.527,1.527,0,0,0-2.264-.608c-2.7,1.43-3.422,4.865-3.72,7.621a47.138,47.138,0,0,1-1.4,7.007c-.556,2.077-1.035,3.959-1.352,5.241-.233-1.443-.518-2.847-.854-4.141-.3-1.139-.6-2.226-.88-3.287a21.907,21.907,0,0,1,2.174-11.1c3.19-6.547,5.493-9.614,3.287-9.756s-5.422,3.306-5.881,8.708a60.63,60.63,0,0,0-.207,9.86c-.7-2.517-1.391-4.885-2.116-7.291a16.007,16.007,0,0,1,.4-8.022c1.507-4.451,6-12.357,3.636-11.736s-5.208,5.208-5.525,10.06a26.682,26.682,0,0,0,.835,7.544c-.518-1.7-1.061-3.442-1.643-5.286-.252-.789-.511-1.63-.77-2.491a2.673,2.673,0,0,0-.065-.44,12.292,12.292,0,0,1,1.294-7.3c2.258-4.069,6.47-7.563,3.979-8.495s-6.237,5.687-6.47,9a15.942,15.942,0,0,0,.3,3.752c-.1-.252-.2-.511-.3-.77-.537-1.9-1.055-3.772-1.507-5.435a15.055,15.055,0,0,1,1.43-7.117c2.213-5.059,5.021-10.863,2.154-9.388-2.31,1.2-4.814,8.029-4.315,13.8-.2-.75-.369-1.4-.511-1.941-.375-3.306-1.087-11.089,0-15.728.712-3.1,1.87-6.023,2.232-9.206a1.993,1.993,0,0,0-.052-.977c-.77-1.941-3.274,1.812-3.681,2.426a14.88,14.88,0,0,0-2.277,8.21,31.568,31.568,0,0,0,.873,7.343,45.106,45.106,0,0,0,1.294,4.561c.317.977.88,2.051,1.294,3.105.213,1.093.459,2.206.712,3.2-3.021-5.823-6.826-18.174-9.012-20.658-2.374-2.7-1.223,3.578,2.336,10.229a101.207,101.207,0,0,0,6.748,10.922c.11.414.226.8.336,1.152.252.776.647,2.1,1.19,3.843-2.407-5.092-6.256-10.216-7.57-10.067-1.9.207-.395,2.633,3.131,6.405a44.179,44.179,0,0,1,6.075,9.187c.6,2.051,1.249,4.328,1.941,6.735-1.753-3.649-5.04-8.2-7.4-11.7-3.435-5.1-5.027-6.2-4.477-2.724s3.694,6.327,7.57,9.789a21.634,21.634,0,0,1,5.305,8.255c.828,3.06,1.669,6.256,2.452,9.426a29.022,29.022,0,0,0-4.471-8.495c-4.3-5.6-9.349-9.7-9.284-7.246s4.089,5.357,8.01,9.821a67.786,67.786,0,0,1,6.418,8.663c.071.323.149.647.226.958-1.792-3.235-4.529-5.823-7.272-8.255-.958-.854-2.4-2.711-3.63-3.105-2.763-.886-1.572,2.672-.647,3.662,2.95,3.235,7.117,5.215,9.828,8.6a31.056,31.056,0,0,1,2.756,4.076q.285,1.669.446,3.125c-1.042-1.042-3.144-2.711-3.293-2.814-3.338-2.245-5.266-5.318-7.828-8.275a5.435,5.435,0,0,0-3.319-2.032c-1.721-.084-2.271,1.76-1.786,3.2,2.019,5.959,9.621,6.217,14.1,9.316a12.85,12.85,0,0,1,2.251,1.824,38.392,38.392,0,0,1,.149,5.532H196.5v4.27h3.047l2.446,15.2h20.477l2.471-15.2h3.047v-4.27H212.6c.705-.848,1.456-1.773,2.213-2.75l3.235.1s11.244.492,15.379-1.727.446-4.367-3.5-3.235-11.717,4.652-13.431,4.6l-1.456-.039c.8-1.042,1.6-2.135,2.368-3.235a73.756,73.756,0,0,0,9.168-2.9c3.235-1.294,6.987-2.316,9.769-4.477a2.944,2.944,0,0,0,1.158-1.475,1.527,1.527,0,0,0-1.236-1.993c-2.95-.8-5.823,1.223-7.925,3.028a46.108,46.108,0,0,1-5.823,4.167c-1.824,1.139-3.455,2.187-4.568,2.911.815-1.216,1.572-2.433,2.206-3.61.556-1.035,1.087-2.031,1.6-3a21.958,21.958,0,0,1,9.168-6.631c6.806-2.588,10.578-3.28,9.058-4.891s-6.224-1.294-10.242,2.355a60.9,60.9,0,0,0-6.884,7.065c1.2-2.316,2.316-4.529,3.435-6.774a15.877,15.877,0,0,1,5.765-5.59c4.134-2.226,12.817-4.936,10.662-6.095s-7.356.246-10.9,3.584a26.3,26.3,0,0,0-4.529,6.082c.776-1.6,1.572-3.235,2.407-4.988.356-.75.738-1.533,1.139-2.342l.252-.369a12.247,12.247,0,0,1,5.926-4.451c4.425-1.43,9.892-1.106,8.708-3.487s-8.443-.1-10.856,2.174a16.177,16.177,0,0,0-2.342,2.95c.1-.252.207-.511.3-.776.9-1.747,1.8-3.468,2.588-4.995a15.1,15.1,0,0,1,5.9-4.218c5.066-2.193,11.083-4.529,7.977-5.389-2.5-.712-8.993,2.588-12.571,7.117.369-.686.686-1.294.945-1.753,1.98-2.678,6.774-8.851,10.72-11.51,2.633-1.779,5.473-3.131,7.913-5.176a1.941,1.941,0,0,0,.647-.757C257.677,160.922,253.3,161.944,252.579,162.119Zm-45.858,53.136c.647-1.009,1.831-2.873,3.118-5.273a30.635,30.635,0,0,0,1.359,3.177c-1.2,2.446-2.284,4.568-2.911,5.118l-1.119.964c-.1-1.307-.252-2.659-.446-3.985Zm7.46,7.084c-.938,1.21-1.8,2.206-2.588,3.041H207.6c-.065-1.624-.175-3.623-.369-5.758l2.433-2.141s1.068-.912,2.517-2.284a20.665,20.665,0,0,1,1.6,4.277A13.18,13.18,0,0,1,214.181,222.339Zm3.313-8.411a30.919,30.919,0,0,1-.77,4.852q-.932,1.417-1.805,2.588a42.293,42.293,0,0,0-.492-4.3,18.765,18.765,0,0,1-.446-3.63,47.873,47.873,0,0,0,3.319-3.707,20.743,20.743,0,0,1,.22,4.186Z",
    transform: "translate(-26.229 -146.627)",
    fill: "#263238"
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Canvas--inject-46",
    transform: "translate(47.707 0)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_508",
    "data-name": "Ellipse 508",
    cx: 60.719,
    cy: 10.183,
    rx: 60.719,
    ry: 10.183,
    transform: "translate(0 199.637)",
    fill: "#ffaf20"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_509",
    "data-name": "Ellipse 509",
    cx: 60.719,
    cy: 10.183,
    rx: 60.719,
    ry: 10.183,
    transform: "translate(0 199.637)",
    fill: "#fff",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2424",
    "data-name": "Rectangle 2424",
    width: 6.412,
    height: 203.817,
    transform: "translate(57.516)",
    fill: "#263238",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.546
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14837",
    "data-name": "Path 14837",
    d: "M189.247,198.019H115.181l.886-6.632H187.92Z",
    transform: "translate(-91.495 -29.52)",
    fill: "#263238",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.546
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14838",
    "data-name": "Path 14838",
    d: "M186.173,270.721h7.511L159.2,62.375h-7.518Z",
    transform: "translate(-82.34 -61.877)",
    fill: "#263238",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.546
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14839",
    "data-name": "Path 14839",
    d: "M112.183,270.721h-7.518l34.05-208.346h7.511Z",
    transform: "translate(-94.132 -61.877)",
    fill: "#263238",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.546
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2425",
    "data-name": "Rectangle 2425",
    width: 30.731,
    height: 4.645,
    transform: "translate(45.353 121.295)",
    fill: "#263238",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.546
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2426",
    "data-name": "Rectangle 2426",
    width: 45.929,
    height: 4.645,
    transform: "translate(37.758 4.704)",
    fill: "#263238",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.546
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2427",
    "data-name": "Rectangle 2427",
    width: 90.641,
    height: 107.754,
    transform: "translate(15.178 9.122)",
    fill: "#fff",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.546
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2428",
    "data-name": "Rectangle 2428",
    width: 101.252,
    height: 5.305,
    transform: "translate(10.093 116.43)",
    fill: "#263238",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.546
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoDataIllu);
export default __webpack_public_path__ + "static/media/no-data-illu.dea23aeefd87ac62e3cd71f7dced3dc7.svg";
export { ForwardRef as ReactComponent };